import { useCallback } from 'react'
import usePersistentState, { TPersistentStateStrategyType } from '../../hooks/usePersistentState'

const useTreeSelectCtrl = <T extends string | number>(
  treeKey: string,
  defaultSelected: T,
  storeStrategy: TPersistentStateStrategyType = 'localstorage'
) => {
  const [selected, setSelected] = usePersistentState(
    { selectedItem: defaultSelected },
    treeKey + '/selected',
    storeStrategy
  )

  const handleSelect = useCallback(
    (item: T) => {
      setSelected({ selectedItem: item })
    },
    [setSelected]
  )

  let selectedLeaf: T = null
  let selectedGroup: T = null
  if (selected.selectedItem) {
    if (selected.selectedItem.toString().includes('-group')) {
      selectedGroup = selected.selectedItem.toString().split('-')[0] as T
    } else {
      selectedLeaf = selected.selectedItem
    }
  }

  return { selectedItem: selected.selectedItem, selectedLeaf, selectedGroup, handleSelect }
}

export default useTreeSelectCtrl
